import React from 'react'
import Modal from 'components/shared/modals/Modal'
import Loader from 'components/shared/Loader/Loader'
import useGetAllTradingPlatformById from 'sdk/hooks/trading/useGetAllTradingPlatformById'
import Button from 'components/shared/Button'

type Props = {
  isOpen: boolean
  onClose: () => void
  onClick: (trade: any) => void
  categoryId: number
  assetId: number
  onOpenCompareModal?: () => void
}
import styles from './TradingModal.module.scss' // eslint-disable-line

export default function TradingModal({
  isOpen, onClose, onClick, onOpenCompareModal, categoryId, assetId,
} :Props) {
  const {
    data: tradingPlatforms,
    isFetching,
  } = useGetAllTradingPlatformById(categoryId, assetId)
  return (
    <Modal
      onClose={onClose}
      isOpen={isOpen}
      onClick={(e: any) => e.stopPropagation()}
      className={styles.followModal}
    >
      <h2 className={styles.title}>Trading platform</h2>
      {
        isFetching ? (
          <Loader />
        ) : (
          <div className={styles.trades}>
            {
              tradingPlatforms?.map((trade) => (trade.active ? (
                <div key={trade.name} className={styles.trade} onClick={() => onClick(trade)}>
                  {/* @ts-ignore */}
                  <img src={trade.logo} alt={trade.name} />
                  { trade.name }
                </div>
              ) : null))
            }
          </div>
        )
      }
      {
        onOpenCompareModal && (
          <Button className={styles.tradeBtn} onClick={onOpenCompareModal}>Compare</Button>
        )
      }
    </Modal>
  )
}
